<template>
    <div class="box">
          
        <nav class="level" v-if="infoOPDObj">
            <div class="level-item has-text-centered " >
                <div>
                    <p class="heading is-size-6 has-text-info">Lab No</p>
                    <p class="title is-size-6 has-text-success">{{infoOPDObj.idlab}}</p>
                </div>
            </div>
            <div class="level-item has-text-centered">
                <div>
                    <p class="heading is-size-6 has-text-info">OPD No.</p>
                    <p class="title is-size-6"   >{{infoOPDObj.idopd}}</p>
                </div>
            </div>

            <div class="level-item has-text-centered">
                <div>
                    <p class="heading is-size-6 has-text-info">Pet Name</p>
                    <p class="title is-size-6" >{{infoOPDObj.opdname}}</p>
                </div>
            </div>

            <div class="level-item has-text-centered">
                <div>
                    <p class="heading is-size-6 has-text-info">Species/Breed</p>
                    <p class="title is-size-6"  >{{infoOPDObj.type}}</p>
                </div>
            </div>


            <div class="level-item has-text-centered">
                <div >
                    <p class="heading is-size-6 has-text-info" >Gender</p>
                    <b-icon pack="fas"  type="is-text" :icon="infoOPDObj.gender === 'M' ? 'mars' : 'venus'" > </b-icon> &nbsp;
                </div>
            </div>


            <div class="level-item has-text-centered">
                <div>
                    <p class="heading is-size-6 has-text-info">Age</p>
                    <p class="title is-size-6"  >{{infoOPDObj.age}}</p>
                </div>
            </div>



            <div class="level-item has-text-centered">
                <div>
                    <p class="heading is-size-6 has-text-info">Owner Name</p>
                    <p class="title is-size-6"  >{{infoOPDObj.owner_name}}</p>
                </div>
            </div>




        </nav> 
    </div>
</template>



<script>
export default {
    name : "InfoOPD",
    props:{
        infoOPDObj : Object,
    }
}
</script>